import React from 'react';

import CoachInfo from '../ISCoachConfigurations/CoachInformation/CoachInfo';
import EmailTemplates from '../ISCoachConfigurations/EmailTemplates';
import MessageTemplates from '../MessageTemplates';
import MobileApp from './MobileApp';
import SlackNotifications from './SlackNotifications';
import CoachSettings from './CoachSettings';
import Fees from './Fees';
import FacebookPixelSettings from './FacebookPixelSettings';
import texts from './texts.json';
import {
  MobileAppIcon,
  SlackNotificationsIcon,
  CoachSettingsIcon,
  MessageTempIcon,
  FeesIcon,
  CoachInfoIcon,
  EmailIcon,
  StyledFbSettingsIcon,
} from './styles';

const tabs = {
  MOBILE_APP: 'MOBILE_APP',
  SLACK_NOTIFICATIONS: 'SLACK_NOTIFICATIONS',
  COACH_SETTINGS: 'COACH_SETTINGS',
  MESSAGE_TEMPLATES: 'MESSAGE_TEMPLATES',
  FEES: 'FEES',
  FACEBOOK_SETTINGS: 'FACEBOOK_SETTINGS',
  COACH_INFO: 'COACH_INFO',
  EMAIL_TEMPLATES: 'EMAIL_TEMPLATES',
};

const tabsConfig = {
  [tabs.MOBILE_APP]: {
    label: texts.tabLabels[tabs.MOBILE_APP],
    icon: MobileAppIcon,
    component: MobileApp,
  },
  [tabs.SLACK_NOTIFICATIONS]: {
    label: texts.tabLabels[tabs.SLACK_NOTIFICATIONS],
    icon: SlackNotificationsIcon,
    component: SlackNotifications,
  },
  [tabs.COACH_SETTINGS]: {
    label: texts.tabLabels[tabs.COACH_SETTINGS],
    icon: CoachSettingsIcon,
    component: CoachSettings,
  },
  [tabs.MESSAGE_TEMPLATES]: {
    label: texts.tabLabels[tabs.MESSAGE_TEMPLATES],
    icon: MessageTempIcon,
    component: (props) => <MessageTemplates {...props} isCAM />,
  },
  [tabs.FEES]: {
    label: texts.tabLabels[tabs.FEES],
    icon: FeesIcon,
    component: (props) => <Fees {...props} />,
  },
  [tabs.COACH_INFO]: {
    label: texts.tabLabels[tabs.COACH_INFO],
    icon: CoachInfoIcon,
    component: CoachInfo,
  },
  [tabs.FACEBOOK_SETTINGS]: {
    label: texts.tabLabels[tabs.FACEBOOK_SETTINGS],
    icon: StyledFbSettingsIcon,
    component: FacebookPixelSettings,
  },
  [tabs.EMAIL_TEMPLATES]: {
    label: texts.tabLabels[tabs.EMAIL_TEMPLATES],
    icon: EmailIcon,
    component: EmailTemplates,
  },
};

export {
  tabs,
  tabsConfig,
};
